// extracted by mini-css-extract-plugin
export default {"container":"Selections_container__E7v15","odds":"Selections_odds__ysXnp","oddsbutton":"Selections_oddsbutton__VmjPv"};